import { SvgIcon } from '@mui/material'
import React from 'react'

const PortalIcon = (props: any): JSX.Element => {
    return <SvgIcon {...props}>
        {/* <!-- Vectors and icons by <a href="https://www.wishforge.games/?ref=svgrepo.com" target="_blank">Wishforge.games</a> in CC Attribution License via <a href="https://www.svgrepo.com/" target="_blank">SVG Repo</a> --> */}
        <svg height="32px" width="32px" fill="currentColor" viewBox="0 0 32 32">
            <g>
                <path d="M23.2,21.8c-0.5,0.5-1.3,0.5-1.8,0c-1.2-1.2-3.3-1.2-4.5,0c-0.5,0.5-1.3,0.5-1.8,0c-1.2-1.2-3.3-1.2-4.5,0
		c-0.5,0.5-1.3,0.5-1.8,0c-1.2-1.2-3.3-1.2-4.5,0c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0c0.5-0.5,1.3-0.5,1.8,0
		c1.2,1.2,3.3,1.2,4.5,0c0.5-0.5,1.3-0.5,1.8,0c1.2,1.2,3.3,1.2,4.5,0c0.5-0.5,1.3-0.5,1.8,0c0.6,0.6,1.4,0.9,2.3,0.9
		s1.6-0.3,2.3-0.9c0.5-0.5,1.3-0.5,1.8,0c0.4,0.4,1,0.4,1.4,0c0.4-0.4,0.4-1,0-1.4C26.4,20.6,24.4,20.6,23.2,21.8z"/>
                <path d="M24.7,25.7c-0.7,0.5-1.8,0.5-2.5,0c-1.4-1.1-3.6-1.1-5,0c-0.7,0.5-1.8,0.5-2.5,0c-1.4-1.1-3.6-1.1-5,0
		c-0.7,0.5-1.8,0.5-2.5,0c-1.4-1.1-3.6-1.1-5,0c-0.4,0.3-0.5,1-0.2,1.4c0.3,0.4,1,0.5,1.4,0.2c0.7-0.5,1.8-0.5,2.5,0
		c1.4,1.1,3.6,1.1,5,0c0.7-0.5,1.8-0.5,2.5,0c0.7,0.6,1.6,0.8,2.5,0.8s1.8-0.3,2.5-0.8c0.7-0.5,1.8-0.5,2.5,0c1.4,1.1,3.6,1.1,5,0
		c0.7-0.5,1.8-0.5,2.5,0c0.4,0.3,1.1,0.3,1.4-0.2c0.3-0.4,0.3-1.1-0.2-1.4C28.2,24.6,26.1,24.6,24.7,25.7z"/>
                <path d="M22.5,17H7c-0.6,0-1,0.4-1,1s0.4,1,1,1h15.5c4.1,0,7.5-3.4,7.5-7.5S26.6,4,22.5,4c-2.7,0-5.1,1.4-6.4,3.6
		C15.5,7.2,14.8,7,14,7c-1.6,0-3.1,1-3.7,2.5c-0.2,0.5,0,1.1,0.5,1.3c0.5,0.2,1.1,0,1.3-0.5C12.5,9.5,13.2,9,14,9c1.1,0,2,0.9,2,2
		s-0.9,2-2,2H7c-0.6,0-1,0.4-1,1s0.4,1,1,1h7c2.2,0,4-1.8,4-4c0-0.7-0.2-1.3-0.5-1.8c0.9-1.9,2.8-3.2,5-3.2c3,0,5.5,2.5,5.5,5.5
		S25.5,17,22.5,17z"/>
                <path d="M3,19h1c0.6,0,1-0.4,1-1s-0.4-1-1-1H3c-0.6,0-1,0.4-1,1S2.4,19,3,19z" />
            </g>
        </svg>
    </SvgIcon>
}
export default PortalIcon